import React from "react";

class PriceLimitHint extends React.Component {
  render() {
    const { limit = {} } = this.props;
    const { min, max, options } = limit;
    return (
      <>
        {min !== undefined && max && (
          <div className="text-xs">
            Number of prices: Min: {min}, Max: {max}
          </div>
        )}
        {options && (
          <div className="text-xs">
            Number of prices: {options.join(" or ")}
          </div>
        )}
      </>
    );
  }
}

export default PriceLimitHint;
